import { $win } from '../utils/globals';

$win.on('resize load orientationchange', function() {
	const windowHeight = $win.height()
	const $hero = $('.js-hero-fullheight');
	const headerHeight = $('.header').outerHeight();
	$hero.css('height', windowHeight - headerHeight)
});
